import {getToken} from "../util/account";
import {getWindflowServerBaseUrl} from "./api";

// 系统消息角色
export type SystemMessageRole = "system" | "feifei" | "feipeng" | "feilian";

// 系统消息类型
export type SystemMessageType = "text";

// 文本消息内容
export interface TextMessageContent {
    text: string;
}

// 系统消息模型
export interface SystemMessageModel {
    id: string;
    user_id: string;
    role: string;
    message_type: string;
    message_content: string;
    created_at: string;
    updated_at: string;
}

// 分页查询系统消息请求
export interface QuerySystemMessageByPageReq {
    user_id?: string;
    role?: string;
    message_type?: string;
    message_content?: string;
    page_num: number;
    page_size: number;
}

// 新增系统消息请求
export interface AddSystemMessageReq {
    user_id?: string;
    role: string;
    message_type: string;
    message_content: string;
}

// 更新系统消息请求
export interface UpdateSystemMessageReq {
    id: string;
    role?: string;
    message_type?: string;
    message_content?: string;
}

// 删除系统消息请求
export interface DeleteSystemMessageReq {
    id: string;
}

// 分页数据
export interface SystemMessagePaginationData {
    total: number;
    list: SystemMessageModel[];
}

// 分页响应
export interface SystemMessagePaginationResp {
    code: number;
    msg: string;
    data: SystemMessagePaginationData;
}

// 操作响应
export interface SystemMessageOpResp {
    code: number;
    msg: string;
    data: string;
}

// 空的分页数据
export const emptySystemMessagePaginationData: SystemMessagePaginationData = {
    total: 0,
    list: []
};

// 空的系统消息模型
export const emptySystemMessage: SystemMessageModel = {
    id: "",
    user_id: "",
    role: "",
    message_type: "",
    message_content: "",
    created_at: "",
    updated_at: ""
};

// 所有角色列表
export const allSystemMessageRoleList: SystemMessageRole[] = ["system", "feifei", "feipeng", "feilian"];

// 获取角色描述
export function getSystemMessageRoleDesc(role: SystemMessageRole): string {
    if (role === "system") return "系统";
    if (role === "feifei") return "飞飞";
    if (role === "feipeng") return "飞蓬";
    if (role === "feilian") return "飞廉";
    return "";
}

// 解析消息内容（JSON格式）
export function parseMessageContent(messageContent: string): TextMessageContent {
    try {
        return JSON.parse(messageContent) as TextMessageContent;
    } catch (e) {
        return {text: messageContent};
    }
}

// 格式化消息内容
export function formatMessageContent(content: TextMessageContent): string {
    return JSON.stringify(content);
}

// 分页查询系统消息
export function querySystemMessageByPage(req: QuerySystemMessageByPageReq, callback: (success: boolean, resp?: SystemMessagePaginationResp) => void) {
    const params = new URLSearchParams();
    if (req.user_id) params.append('user_id', req.user_id);
    if (req.role) params.append('role', req.role);
    if (req.message_type) params.append('message_type', req.message_type);
    if (req.message_content) params.append('message_content', req.message_content);
    params.append('page_num', req.page_num.toString());
    params.append('page_size', req.page_size.toString());

    fetch(getWindflowServerBaseUrl() + "/system/querySystemMessageByPage?" + params.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": getToken()
        }
    }).then(response => response.json())
        .then(res => {
            try {
                let resp = res as SystemMessagePaginationResp;
                callback(resp.code === 200, resp);
            } catch (e) {
                callback(false, undefined);
            }
        })
        .catch(error => {
            console.error("Error:", error);
            callback(false, undefined);
        });
}

// 新增系统消息
export function addSystemMessage(req: AddSystemMessageReq, callback: (success: boolean, resp?: SystemMessageOpResp) => void) {
    fetch(getWindflowServerBaseUrl() + "/system/addSystemMessage", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": getToken()
        },
        body: JSON.stringify(req)
    }).then(response => response.json())
        .then(res => {
            try {
                let resp = res as SystemMessageOpResp;
                callback(resp.code === 200, resp);
            } catch (e) {
                callback(false, undefined);
            }
        })
        .catch(error => {
            console.error("Error:", error);
            callback(false, undefined);
        });
}

// 更新系统消息
export function updateSystemMessage(req: UpdateSystemMessageReq, callback: (success: boolean, resp?: SystemMessageOpResp) => void) {
    fetch(getWindflowServerBaseUrl() + "/system/updateSystemMessage", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": getToken()
        },
        body: JSON.stringify(req)
    }).then(response => response.json())
        .then(res => {
            try {
                let resp = res as SystemMessageOpResp;
                callback(resp.code === 200, resp);
            } catch (e) {
                callback(false, undefined);
            }
        })
        .catch(error => {
            console.error("Error:", error);
            callback(false, undefined);
        });
}

// 删除系统消息
export function deleteSystemMessage(req: DeleteSystemMessageReq, callback: (success: boolean, resp?: SystemMessageOpResp) => void) {
    fetch(getWindflowServerBaseUrl() + "/system/deleteSystemMessage", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": getToken()
        },
        body: JSON.stringify(req)
    }).then(response => response.json())
        .then(res => {
            try {
                let resp = res as SystemMessageOpResp;
                callback(resp.code === 200, resp);
            } catch (e) {
                callback(false, undefined);
            }
        })
        .catch(error => {
            console.error("Error:", error);
            callback(false, undefined);
        });
}
